const c = {
  name: "HandsTouch",
  dimensions: { width: 35, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 35 39.7" style="enable-background:new 0 0 35 39.7;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M19,5.7c0-1.7-0.7-3.2-1.8-4.2L18.7,0C20.1,1.4,21,3.4,21,5.7c0,1.5-0.4,2.9-1.1,4.1c1.4,0.3,2.4,1.3,2.9,2.6
			c0.6-0.4,1.4-0.7,2.2-0.7c1.7,0,3.2,1.1,3.8,2.7c0.6-0.4,1.4-0.7,2.2-0.7c2.2,0,4,1.8,4,4v9c0,7.2-5.8,13-13,13
			c-2.4,0-4.7-0.5-6.8-1.4l0,0c-2.1-1-4-2.3-5.6-4.1l-6.7-7.5l-1.9-2.3c-1.4-1.7-1.2-4.2,0.5-5.6l0,0C2.2,18,3.1,17.7,4,17.7
			c1.1,0,2.2,0.5,3,1.4l2,2.1V5.7c0-1.1,0.5-2.1,1.2-2.8c0.7-0.7,1.7-1.2,2.8-1.2s2.1,0.5,2.8,1.2C16.5,3.5,17,4.5,17,5.7v4.5
			c0.1-0.1,0.2-0.2,0.2-0.2C18.3,8.8,19,7.3,19,5.7z M17.9,12c0,0-0.1,0.1-0.1,0.1C17.3,12.5,17,13,17,13.7v4h-2v-12
			c0-0.6-0.2-1.1-0.6-1.4c-0.4-0.4-0.9-0.6-1.4-0.6c-0.6,0-1.1,0.2-1.4,0.6C11.2,4.6,11,5.1,11,5.7v20.5l-5.4-5.7l0,0
			c-0.4-0.5-1-0.7-1.5-0.7c-0.5,0-0.9,0.2-1.3,0.5c-0.8,0.7-1,2-0.2,2.8l0,0l1.9,2.3l6.7,7.5c1.4,1.6,3.1,2.8,4.9,3.6
			c1.9,0.8,3.9,1.3,6,1.3c6.1,0,11-4.9,11-11v-9c0-1.1-0.9-2-2-2c-1.1,0-2,0.9-2,2h-2v-2c0-1.1-0.9-2-2-2s-2,0.9-2,2v2h-2v-4
			c0-1.1-0.9-2-2-2C18.6,11.7,18.2,11.8,17.9,12z"/>
		<path class="st0" d="M7,5.7C7,4,7.7,2.5,8.8,1.4L7.3,0C5.9,1.4,5,3.4,5,5.7c0,2.2,0.9,4.2,2.3,5.7l1.4-1.4C7.7,8.8,7,7.3,7,5.7z"
			/>
	</g>
</g>
</svg>
  `
};
export {
  c as HandsTouch
};
